export default __webpack_public_path__ + "static/media/rewards2.1128d2d1.svg";